import React from 'react';
import { H1 } from '@hobs/components/Headings';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next/src/index';
import { withRouter } from 'react-router-dom';
import WithRoles from '@hobs/hocs/WithRoles';
import { PHASE_TYPES, USER_ROLES } from '@hobs/utils/constants';
import PropTypes from 'prop-types';
import Tabs from '@hobs/components/Tabs';
import Confirm from '@hobs/components/Confirm';
import { getAssignedPartyUnits } from '../../actions/parties';
import { getSorSummary } from '../../actions/sor';
import SorUnits from './Units/SorUnits';
import SorApprovals from './Units/SorApprovals';
import SorCor from './Units/SorCor';
import './StatementOfRequirements.scss';

class StatementOfRequirements extends React.PureComponent {
  componentDidMount() {
    this.fetchAdminAssignedPartyUnits();
    this.props.getSorSummary();
  }

  hasCorrectPhaseForEdit() {
    const { sor } = this.props;

    return (
      sor.sorSummary.phaseType != PHASE_TYPES.Billing.name &&
      sor.sorSummary.phaseType != PHASE_TYPES.Finished.name
    );
  }

  fetchAdminAssignedPartyUnits() {
    const { hasUserPermission } = this.props;

    if (hasUserPermission(USER_ROLES.ADMIN)) {
      this.props.getAssignedPartyUnits();
    }
  }

  hasUnitAssigned() {
    const { assignedPartyUnits } = this.props;
    return Array.isArray(assignedPartyUnits) && assignedPartyUnits.length > 0;
  }

  getSelectedTabFromQuery() {
    const searchParams = new URLSearchParams(this.props.location.search);
    return searchParams.get('tab');
  }

  getTabIndexBasedOnQuery(tab) {
    switch (tab) {
      case 'units':
        return 0;
      case 'cor':
        return 1;
      case 'approvals':
        return 2;
      default:
        return 0;
    }
  }

  render() {
    const {
      t,
      sorId,
      hasUserPermission,
      location,
      match,
      history
    } = this.props;
    return (
      <>
        <H1>{t('SOR requisites')}</H1>
        <Tabs
          activeTab={this.getTabIndexBasedOnQuery(
            this.getSelectedTabFromQuery()
          )}
          onTabClick={() => this.props.history.push(`/sor-requisites`)}
          className="sor-tabs"
        >
          <Tabs.Tab
            component={
              <SorUnits
                sorId={sorId}
                disabled={
                  !hasUserPermission(USER_ROLES.ADMIN) ||
                  !this.hasCorrectPhaseForEdit()
                }
                canCreateUnit={
                  hasUserPermission(USER_ROLES.ADMIN) && !this.hasUnitAssigned()
                }
              />
            }
          >
            {t('Units')}
          </Tabs.Tab>
          <Tabs.Tab
            component={
              <SorCor
                disabled={
                  hasUserPermission(USER_ROLES.READONLY) ||
                  hasUserPermission(USER_ROLES.HOST_UNIT) ||
                  !this.hasCorrectPhaseForEdit()
                }
              />
            }
          >
            {t('COR')}
          </Tabs.Tab>
          <Tabs.Tab
            component={
              <SorApprovals
                location={location}
                match={match}
                history={history}
                sorId={sorId}
                disabled={!hasUserPermission(USER_ROLES.ADMIN)}
              />
            }
            validateTabChange={completeTabChange => {
              if (this.props.sor.sorSummary.canFsorBeConfirmed) {
                Confirm(
                  t('Attention'),
                  'All services are approved by units. Do you really want to leave the page without confirming FSOR?',
                  () => {
                    completeTabChange(true);
                  },
                  () => {
                    completeTabChange(false);
                  },
                  t('Yes'),
                  t('No')
                );
              } else {
                completeTabChange(true);
              }
            }}
          >
            {t('Approvals')}
          </Tabs.Tab>
        </Tabs>
      </>
    );
  }
}

StatementOfRequirements.propTypes = {
  sorId: PropTypes.string, // GUID
  t: PropTypes.func,
  hasUserPermission: PropTypes.func,
  location: PropTypes.object,
  match: PropTypes.object,
  history: PropTypes.object,
  assignedPartyUnits: PropTypes.array,
  getAssignedPartyUnits: PropTypes.func,
  sor: PropTypes.object,
  getSorSummary: PropTypes.func
};

const mapStateToProps = (state, { match }) => {
  const sorId = match.params.sorId;
  return {
    sorId,
    assignedPartyUnits: state.parties.assignedPartyUnits,
    sor: state.sor
  };
};
const mapDispatchToProps = {
  getAssignedPartyUnits,
  getSorSummary
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withRouter(WithRoles(StatementOfRequirements))));
